import React from 'react';
import { ICON_URL } from '../../data/site';
type PhotoSlotProps = {
  /** Supply a photo larger than it displays (2x) so it only ever scales down. */
  src?: string;
  alt: string;
  label: string;
  tone?: 'dark' | 'light';
  className?: string;
  /** Load immediately (above-the-fold images). */
  priority?: boolean;
};
export function PhotoSlot({
  src,
  alt,
  label,
  tone = 'light',
  className = '',
  priority = false
}: PhotoSlotProps) {
  if (src) {
    return <img src={src} alt={alt} loading={priority ? 'eager' : 'lazy'} decoding="async" className={`block h-full w-full object-cover object-top ${className}`} data-id="element-245" data-mp="19pfaesykdkhm" />;
  }
  const dark = tone === 'dark';
  return <div role="img" aria-label={alt} className={`relative flex h-full w-full items-center justify-center overflow-hidden ${dark ? 'bg-white/[0.08] ring-1 ring-inset ring-white/20' : 'bg-[#e8eef8] ring-1 ring-inset ring-brand-navy/10'} ${className}`} data-id="element-246" data-mp="1nliv9vnjsghf">
      <div className="flex aspect-square w-[clamp(5rem,8vw,8rem)] items-center justify-center rounded-full bg-white p-[clamp(0.9rem,1.4vw,1.5rem)] shadow-[0_8px_30px_rgba(21,52,136,0.18)]" data-id="element-247" data-mp="2dhr0ztokpa6v">
        <img src={ICON_URL} alt="" aria-hidden="true" className="h-auto w-full max-w-[130px]" data-id="element-248" data-mp="23s7hclt1dcay" />
      </div>
      <span className={`absolute bottom-[clamp(1rem,2vw,2rem)] left-1/2 -translate-x-1/2 whitespace-nowrap text-[clamp(0.7rem,0.65rem+0.15vw,0.9rem)] font-semibold uppercase tracking-[0.16em] ${dark ? 'text-white/75' : 'text-brand-navy/60'}`} data-id="element-249" data-mp="1zqvng434q4wy">
        {label}
      </span>
    </div>;
}